import LazyLoad from 'vanilla-lazyload';
import * as Sentry from '@sentry/browser';
import CartHeader from './CartHeader/CartHeader';
import MenuPrimaryMobile from './MenuPrimaryMobile/MenuPrimaryMobile';
import SliderInterface from '../Slider/interfaces/SliderInterface';
import MenuSticky from './MenuSticky/MenuSticky';
import MediaQueries from '../../shared/helpers/MediaQueries';
import SwitcherLanguage from './SwitcherLanguage/SwitcherLanguage';
import AccountHeader from './AccountHeader/AccountHeader';
import SearchChunk from '../../modules/InitChunks/SearchChunk/SearchChunk';

/**
 * Class Header.
 */
export default class Header {
  constructor() {
    // Scroll in the page
    new MenuSticky();

    // Cart Header
    new CartHeader();

    // Switcher Language
    new SwitcherLanguage();

    // Images
    Header.images();

    // Menus
    Header.menus();

    // Account
    AccountHeader.menuDesktop();

    window.addEventListener(
      'load',
      () => {
        // Add search on refonte
        new SearchChunk();
      },
      { passive: true }
    );

    Header.currentMenu();
  }

  /*
   * Add all images script in page
   * */
  private static images() {
    // LazyLoad
    const lazyLoadOptions = {};
    window.LAZY_LOAD = new LazyLoad(lazyLoadOptions);
  }

  /*
   * Add menus in page
   * */
  private static menus() {
    const isNewVersionMenu =
      document.getElementsByClassName('c-menuPrimaryNew');
    let selectorMenu = '.c-menuPrimary';
    let optionsSlider = {};

    // Load new menu settings
    if (isNewVersionMenu.length > 0) {
      selectorMenu = '.c-menuPrimaryNew';
      optionsSlider = { slidesPerView: 2 };
    }

    // Menu
    const eltMenu: HTMLElement = document.querySelector(selectorMenu);

    // Sliders
    Header.importSlider(eltMenu, optionsSlider);

    // For Mobile & tablet & LG
    if (!MediaQueries.xl.matches) {
      // Menu primary
      new MenuPrimaryMobile(
        '.js-menuOpen',
        '.js-menuClose',
        selectorMenu,
        '.js-menuItem',
        {
          slidesPerView: 'auto',
          spaceBetween: 15,
        }
      );
    }
  }

  /*
   * Import dynamically slider in menu
   * */
  private static importSlider(eltMenu: HTMLElement, options: {}) {
    if (eltMenu) {
      eltMenu.addEventListener(
        'mouseenter',
        () => {
          import(
            /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-slider' */ '../Slider/Slider'
          ).then(({ default: Slider }) => {
            const slidersMenu: NodeListOf<HTMLElement> =
              document.querySelectorAll(
                '.js-sliderMenu--container .js-sliderMenu'
              );

            // Add slider in all element slider
            slidersMenu.forEach((slider: HTMLElement) => {
              const sliderMenu: SliderInterface = {
                selector: `#${slider.id}`,
                options,
              };
              const sliderSwipper = new Slider(sliderMenu);
              sliderSwipper.create();
            });
          });
        },
        { once: true, passive: true }
      );
    }
  }

  private static currentMenu() {
    const input: HTMLInputElement = document.querySelector('input#universe');

    if (input) {
      const currentUniverse = input.value;

      document.querySelectorAll('.js-menuItem').forEach((item: HTMLElement) => {
        const { universe } = item.dataset;

        if (currentUniverse === universe) {
          item.classList.add('is-active');
        }
      });
    } else {
      const message = '[EMINZA-CURRENT-MENU] error: hidden input unavailable';

      Sentry.captureException(message);
    }
  }
}

declare global {
  interface Window {
    LAZY_LOAD: any;
  }
}
